module.exports = __webpack_public_path__ + "static/066ffe86bf11379771223eb7c01b7eae31768b7789463b9c89ae7e6bfd2ab678-68cd57d53134f3f6861658735a7a9ca6.png";